import React, { Component, Fragment } from 'react';
import { Button, Grid, Icon, Label, Popup, Segment } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { sanitizeRichText } from '../../util/richText';
import AnnouncementEdit from './AnnouncementEdit';
import 'react-quill/dist/quill.snow.css';

class AnnouncementsTable extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            confirmation: false,
            contentIndex: null,
            editingId: null
        };
        this.deleteAnnouncement = this.deleteAnnouncement.bind(this);
        this.toggleContent = this.toggleContent.bind(this);
        this.toggleEdit = this.toggleEdit.bind(this);
        this.closeEdit = this.closeEdit.bind(this);
    }

    deleteAnnouncement(announcementId) {
        axios.delete(`/announcement/delete/${announcementId}`)
            .then(() => {
                this.setState({ confirmation: false, editingId: null });
                toast('Uspješno ste izbrisali obavještenje!');
                this.props.fetchData();
            })
            .catch(() => {
                toast('Došlo je do greške pri brisanju obavještenja.');
            });
    }

    toggleContent(index) {
        this.setState(prevState => ({
            contentIndex: prevState.contentIndex === index ? null : index,
            editingId: null,
            confirmation: false
        }));
    }

    toggleEdit(event, announcementId, index) {
        event.stopPropagation();
        this.setState(prevState => ({
            editingId: prevState.editingId === announcementId ? null : announcementId,
            contentIndex: index,
            confirmation: false
        }));
    }

    closeEdit() {
        this.setState({ editingId: null });
    }

    formatDate(dateValue) {
        if (!dateValue) return '-';
        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) return '-';
        return `${String(date.getDate()).padStart(2, '0')}. ${String(date.getMonth() + 1).padStart(2, '0')}. ${date.getFullYear()}.`;
    }

    formatCreatorRole(role) {
        const roleNames = {
            administrator: 'Administrator',
            aida: 'AIDA',
            international_cooperation_office: 'Služba za međunarodnu saradnju'
        };

        return roleNames[role] || role || 'Nije evidentirana';
    }

    renderRoles(announcement) {
        if (!announcement.userTypes || !announcement.userTypes.length) {
            return (
                <Label as="a" basic>
                    <Icon name="users" />
                    Nema uloga
                </Label>
            );
        }

        return announcement.userTypes.map(userType => (
            <Label as="a" basic key={userType.id} style={{ marginTop: '6px' }}>
                <Icon name="users" />
                {userType.name}
            </Label>
        ));
    }

    renderActions(el, index) {
        if (this.state.confirmation === index) {
            return (
                <div onClick={event => event.stopPropagation()}>
                    <span style={{ marginRight: '10px', fontWeight: 700 }}>Jeste li sigurni?</span>
                    <Button.Group size="tiny">
                        <Button
                            basic
                            color="blue"
                            onClick={() => this.deleteAnnouncement(el.id)}
                        >
                            DA
                        </Button>
                        <Button
                            basic
                            color="red"
                            onClick={() => this.setState({ confirmation: false })}
                        >
                            NE
                        </Button>
                    </Button.Group>
                </div>
            );
        }

        return (
            <Fragment>
                <Popup
                    content="Izmjena"
                    position="top center"
                    trigger={
                        <Button
                            disabled={localStorage.getItem('activeRole') === 'Support'}
                            basic
                            circular
                            icon="pencil"
                            size="tiny"
                            color="green"
                            onClick={event => this.toggleEdit(event, el.id, index)}
                        />
                    }
                />
                <Popup
                    content="Brisanje"
                    position="top center"
                    trigger={
                        <Button
                            disabled={localStorage.getItem('activeRole') === 'Support'}
                            basic
                            circular
                            icon="trash alternate"
                            size="tiny"
                            color="red"
                            onClick={(event) => {
                                event.stopPropagation();
                                this.setState({ confirmation: index, editingId: null });
                            }}
                        />
                    }
                />
            </Fragment>
        );
    }

    render() {
        const { data } = this.props;
        const activeRole = localStorage.getItem('activeRole') || '';
        const showActions = activeRole.substr(0, 10) !== 'Studentska';
        const showCreatorUsername = activeRole.substr(0, 13) === 'Administrator' || activeRole === 'AIDA';

        return (
            <div>
                {data.length ? data.map((el, index) => {
                    const isOpen = index === this.state.contentIndex;
                    const isEditing = this.state.editingId === el.id;

                    return (
                        <Segment
                            key={el.id}
                            onClick={() => this.toggleContent(index)}
                            style={{
                                position: 'relative',
                                borderLeft: isOpen ? '4px solid #14b8a6' : '4px solid #2185d0',
                                marginBottom: '18px',
                                padding: '18px 26px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                transition: 'all 0.2s ease',
                                backgroundColor: '#fff'
                            }}
                        >
                            <Grid columns={2} stackable verticalAlign="middle">
                                <Grid.Column width={showActions ? 12 : 14}>
                                    <div
                                        style={{
                                            color: '#000',
                                            fontWeight: 700,
                                            lineHeight: 1.25,
                                            fontSize: '18px',
                                            marginTop: '-4px'
                                        }}
                                    >
                                        {el.title || el.titleEng}
                                    </div>
                                </Grid.Column>

                                {showActions && (
                                    <Grid.Column width={3} textAlign="right">
                                        {this.renderActions(el, index)}
                                    </Grid.Column>
                                )}

                                <Grid.Column width={1} textAlign="right">
                                    <Icon
                                        name={isOpen ? 'angle up' : 'angle down'}
                                        style={{
                                            color: '#1d2d50',
                                            margin: 0
                                        }}
                                    />
                                </Grid.Column>
                            </Grid>

                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    fontSize: '12px',
                                    fontWeight: 700,
                                    color: 'grey',
                                    marginTop: '6px',
                                    marginBottom: '10px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.4px',
                                    lineHeight: 1
                                }}
                            >
                                <Icon
                                    name="calendar alternate outline"
                                    style={{
                                        color: '#14b8a6',
                                        fontSize: '12px',
                                        margin: 0,
                                        lineHeight: 1,
                                        display: 'block'
                                    }}
                                />
                                <span style={{ display: 'flex', alignItems: 'center', lineHeight: 1 }}>
                                    {this.formatDate(el.date || el.createdAt || el.creationDate)}
                                </span>
                                {el.createdByRole && (
                                    <span style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        lineHeight: 1,
                                        textTransform: 'none'
                                    }}>
                                        <Icon name="user outline" style={{ marginLeft: '8px' }} />
                                        <span>
                                            {this.formatCreatorRole(el.createdByRole)}
                                            {showCreatorUsername && el.createdByUsername &&
                                                el.createdByRole !== 'administrator' &&
                                                el.createdByRole !== 'Administrator' &&
                                                ` (${el.createdByUsername})`}
                                        </span>
                                    </span>
                                )}
                            </div>

                            {isOpen && !isEditing && (
                                <div
                                    className="ql-editor"
                                    style={{
                                        marginTop: '18px',
                                        paddingTop: '16px',
                                        borderTop: '1px solid #ececec',
                                        lineHeight: 1.7,
                                        color: '#444',
                                        whiteSpace: 'normal',
                                        textAlign: 'justify'
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: sanitizeRichText(el.content || el.contentEng)
                                    }}
                                />
                            )}

                            {isEditing && (
                                <div
                                    onClick={event => event.stopPropagation()}
                                    style={{
                                        marginTop: '18px',
                                        paddingTop: '16px',
                                        borderTop: '1px solid #ececec',
                                        cursor: 'default'
                                    }}
                                >
                                    <AnnouncementEdit
                                        announcement={el}
                                        fetchData={this.props.fetchData}
                                        onCloseForm={this.closeEdit}
                                    />
                                </div>
                            )}

                            <div
                                style={{
                                    marginTop: '14px',
                                    paddingTop: '12px',
                                    borderTop: isOpen ? '1px solid #ececec' : '0'
                                }}
                                onClick={event => event.stopPropagation()}
                            >
                                {this.renderRoles(el)}
                            </div>
                        </Segment>
                    );
                }) : 'Trenutno nema obavještenja.'}
            </div>
        );
    }
}

export default AnnouncementsTable;



// WEBPACK FOOTER //
// ./src/views/Admin/Announcements/AnnouncementsTable.js